import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import { Draggable } from 'react-beautiful-dnd';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { GoalWithId, FormValues } from '../../../../../../../common/types';
import { EditableGoal } from './fields/main.tsx';

type Props = {
	isDraggable?: boolean;
	index: number;
	goal: GoalWithId;
	getFormValues: () => FormValues;
	onSaveGoal: (modifiedGoal: GoalWithId) => void;
	onRemoveGoal: () => void;
};

// @ts-expect-error - TS2304 - Cannot find name 'DraggableStyle'.
const getItemStyle = (isDragging: boolean, draggableStyle: DraggableStyle | null | undefined) => ({
	userSelect: 'none',
	padding: token('space.025', '2px'),
	background: isDragging ? token('elevation.surface', colors.N10) : 'transparent',
	...draggableStyle,
});

export const EditableGoalField = ({
	index,
	goal,
	onRemoveGoal,
	isDraggable,
	onSaveGoal,
	getFormValues,
}: Props) => {
	if (isDraggable === true) {
		return (
			<Draggable
				data-testid="servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.draggable"
				draggableId={goal.id}
				index={index}
			>
				{(provided, snapshot) => (
					<div
						ref={provided.innerRef}
						{...provided.draggableProps}
						{...provided.dragHandleProps}
						// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
					>
						<EditableGoal
							index={index}
							goal={goal}
							onSaveGoal={onSaveGoal}
							onRemoveGoal={onRemoveGoal}
							getFormValues={getFormValues}
						/>
					</div>
				)}
			</Draggable>
		);
	}

	return (
		<EditableGoal
			index={index}
			goal={goal}
			onSaveGoal={onSaveGoal}
			onRemoveGoal={onRemoveGoal}
			getFormValues={getFormValues}
		/>
	);
};
